function setMinContentHeight() {
    $('main').css(
        'min-height',
        $(window).height() -
            ($('.header.fixed').height() + $('footer').height() + parseInt($('footer').css('margin-top')))
    );
}

$(document).ready(function () {
    setMinContentHeight();
    $(window).on('resized', setMinContentHeight);
});
